<template>
  <div v-if="showPresell" class="presell">
    <section class="presell__info">
      <!-- <div v-if="detail&&detail.paid_money_ladder&&detail.paid_money_ladder.length">
        <p v-for="(item, index) in detail.paid_money_ladder" :key="'paid'+index">前{{item.amount}}名支付定金，定金优惠￥{{item.price}}</p>
      </div> -->
      <div v-if="detail && detail.priceLadder && detail.priceLadder.length">
        <p v-for="(item, index) in detail.priceLadder" :key="index">
          预定达到{{ item.amount }}件，尾款优惠￥{{ item.price }}
        </p>
      </div>
      <div v-else>
        <p v-if="detail && !detail.priceLadder.length">
          预定达到{{ detail.minCount }}件，即可成功出道哦~
        </p>
      </div>
      <img v-if="Env.isMgtvApp" :src="sharePng" @click="share"/>
    </section>
    <div v-if="detail && detail.priceLadder && detail.priceLadder.length">
      <section v-if="showProgress" class="presell__num">
        <ul>
          <li>已预定{{ detail.actCount }}件</li>
          <li v-for="(item, index) in detail.priceLadder" :key="index">
            {{ item.amount }}件
          </li>
        </ul>
        <div>
          <p :style="nowStyle"></p>
        </div>
        <ul>
          <li>尾款优惠</li>
          <li v-for="(item, index) in detail.priceLadder" :key="index">
            ￥{{ item.price }}
          </li>
        </ul>
      </section>
    </div>
    <div v-else>
      <section v-if="showProgress" class="presell__num">
        <ul>
          <li>已预定{{ detail.actCount }}件</li>
          <li>{{ detail.minAmount }}件</li>
        </ul>
        <div>
          <p :style="nowStyle"></p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import Env from 'utils/env';
import sharePng from 'assets/img/pre_share.png';
import _ from 'lodash';

export default {
  props: ['isPreSell', 'preSellInfo'],
  data() {
    return {
      Env,
      sharePng,
      detail: {
        priceLadder: [],
        paid_money_ladder: [],
        actCount: 0,
        minAmount: '',
      },
    };
  },
  watch: {
    preSellInfo: {
      handler(val) {
        if (!_.isEmpty(val)) {
          _.assign(this.detail, val);
        }
      },
      immediate: true,
    },
  },
  computed: {
    showPresell() {
      const { isPreSell } = this;
      return isPreSell;
    },
    showProgress() {
      const { isPreSell } = this;
      return isPreSell;
    },
    nowStyle() {
      const {
        detail: { priceLadder, actCount, minCount },
      } = this;
      if (!priceLadder.length) {
        const per = Number(((actCount / minCount) * 100).toFixed(2));
        let style = '';
        if (actCount) {
          style += 'min-width:3px;';
        }
        style += `width: ${per}%`;
        return style;
      }
      const len = priceLadder.length;
      const maxNum = Number(priceLadder[len - 1].amount);
      let per = Number(((actCount / maxNum) * 100).toFixed(2));
      if (len === 2) {
        const secondNum = Number(priceLadder[0].amount);
        if (actCount < secondNum) {
          per = Number(((actCount / secondNum) * 50).toFixed(2));
        } else if (actCount === secondNum) {
          per = 50;
        } else {
          per =
              50 +
              Number(Number(((actCount - secondNum) / (maxNum - secondNum)) * 50).toFixed(2));
        }
      }

      let style = '';
      if (actCount) {
        style += 'min-width:3px;';
      }
      style += `width: ${per}%`;
      return style;
    },
  },
  methods: {
    share() {
      this.$emit('share');
    },
  },
};
</script>
<style lang="scss" scoped>
.presell {
  padding: 20px 30px 12px 30px;
  background: #fff;

  &__info {
    font-size: 22px;
    display: flex;
    // justify-content: space-between;
    flex-direction: column;
    margin-bottom: 10px;

    div {
      margin-right: 10px;
    }

    img {
      display: block;
      width: 180px;
      height: 94px;
    }

    p {
      height: 35px;
      line-height: 40px;

      &::before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        margin: 0 10px 4px 0;
        background: rgba(249, 67, 90, 1);
      }
    }
  }

  &__num {
    div {
      height: 18px;
      background: rgba(216, 216, 216, 1);
      border-radius: 11px;
      position: relative;
      margin-bottom: 10px;

      p {
        position: absolute;
        height: 100px;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0;
        max-width: 100%;
        height: 100%;
        border-radius: 11px;
        background: linear-gradient(
                90deg,
                rgba(245, 77, 77, 1) 0%,
                rgba(255, 84, 0, 1) 100%
        );
      }
    }

    ul {
      display: flex;
      justify-content: space-between;
      font-size: 22px;
      height: 35px;
      align-items: center;

      &:nth-of-type(1) {
        li:nth-of-type(1) {
          color: #ff8315;
        }

        li:nth-of-type(2) {
          margin-left: -30px;
        }
      }

      li:nth-of-type(2) {
        margin-left: -15px;
      }
    }
  }
}
</style>
